define('uikit/modules/instant.notifications',['require','exports','module','underscore','backbone','marionette','../channel','../mixins/component.mixin','./instant.notification'],function(require, exports, module){
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var InstantNotification = require('./instant.notification');

  var InstantNotifications = Mn.CollectionView.extend(ComponentMixin).extend({

    className: 'ui instant notifications',

    childView: InstantNotification,

    childViewEventPrefix: 'notification',

    options: {
      limit: 5
    },

    forceUpdate: { limit: true },

    collectionEvents: {
      'add' : 'limitNotifications'
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      if (!this.collection) {
        this.collection = new Backbone.Collection([], { model: InstantNotification.Model });
      }
    },

    limitNotifications: function() {
      if (this.collection.length > this.getOption('limit')) {
        this.collection.shift();
      }
    },

    onNotificationClose: function(e) {
      this.collection.remove(e.model);
    },

    /**
     *  Add a new notification, whether specifiying
     *  a collection, model(/single definition) or array of models(/definitions)
     */
    add: function(notifications) {
      var isCollection = !!(notifications instanceof Backbone.Collection);

      if (isCollection) {
        this.collection.reset(notifications.models);
      } else {
        this.collection.add(notifications, { at: 0 });
      }
    },

    /**
     *  Clear all notifications currently attached
     */
    clear: function() {
      this.collection.reset();
    }

  });

  channel.reply('instant-notifications', function() {
    return InstantNotifications;
  });

  module.exports = InstantNotifications;

});

